/**
 * Header Component
 * 대시보드 헤더 (사용자 메뉴 포함)
 */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { balanceApi } from "../../../api/balanceApi";
import "../../../styles/Header.css";

interface HeaderProps {
  userName?: string;
  userEmail?: string;
  userType?: string;
}

const Header: React.FC<HeaderProps> = ({
  userName,
  userEmail,
  userType,
}) => {
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [balance, setBalance] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // props가 전달되면 로딩 완료
    if (userName) {
      setIsLoading(false);
    }
  }, [userName]);

  useEffect(() => {
    if (userType !== "SUPPLIER" && userType !== "HEADQUARTERS") return;

    const fetchBalance = async () => {
      try {
        const response = await balanceApi.getBalance();
        setBalance(response.balance);
      } catch {
        setBalance(null);
      }
    };
    fetchBalance();
  }, [userType]);

  const handleLogout = () => {
    // 로그아웃 처리
    localStorage.removeItem("accessToken");
    localStorage.removeItem("sessionId");
    localStorage.removeItem("USER_ID");
    localStorage.removeItem("USER_NAME");
    localStorage.removeItem("USER_TYPE");
    localStorage.removeItem("PHONE_NUM");
    localStorage.removeItem("ADMIN_YN");
    localStorage.removeItem("SUPP_TYPE");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("rememberMe");
    localStorage.removeItem("DASHBOARD_TABS");
    localStorage.removeItem("CURRENT_PAGE");
    localStorage.removeItem("ACTIVE_TAB_ID");
    navigate("/login");
  };

  return (
    <header className="header">
      <div className="header-left">
        <button className="mobile-menu-btn">
          <i className="fas fa-bars"></i>
        </button>
        <h1 className="header-title">라이더 정산 시스템</h1>
      </div>

      <div className="header-right">
        {/* 잔액 + 사용자 정보 */}
        <div className="user-section">
          {/* 잔액 표시 */}
          {userType === "SUPPLIER" && balance !== null && (
            <>
              <div className="balance-display">
                <i className="fas fa-wallet"></i>
                <span>{balance.toLocaleString()}원</span>
              </div>
              <div className="divider"></div>
            </>
          )}

          {/* 사용자 메뉴 */}
          <div className="user-menu">
            <div
              className="user-info"
              onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
            >
              <div className="user-details">
                {isLoading ? (
                  <div className="user-name" style={{ opacity: 0.6 }}>...</div>
                ) : (
                  <>
                    <div className="user-name">{userName}</div>
                    {userEmail && <div className="user-email">{userEmail}</div>}
                  </>
                )}
              </div>
              <i
                className={`fas fa-chevron-down user-menu-arrow ${isUserMenuOpen ? "open" : ""}`}
              ></i>
            </div>

            {isUserMenuOpen && (
              <div className="user-dropdown">
                {/*<a href="#" className="user-dropdown-item" onClick={(e) => e.preventDefault()}>*/}
                {/*    <i className="fas fa-user"></i> 내 정보*/}
                {/*</a>*/}
                {/*{userType === 'SUPPLIER' && (*/}
                {/*    <a href="#" className="user-dropdown-item" onClick={(e) => e.preventDefault()}>*/}
                {/*        <i className="fas fa-building"></i> 협력사 변경*/}
                {/*    </a>*/}
                {/*)}*/}
                {/*<a href="#" className="user-dropdown-item" onClick={(e) => e.preventDefault()}>*/}
                {/*    <i className="fas fa-cog"></i> 설정*/}
                {/*</a>*/}
                <a
                  href="#"
                  className="user-dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  <i className="fas fa-sign-out-alt"></i> 로그아웃
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Overlay for closing dropdown */}
      {isUserMenuOpen && (
        <div
          className="dropdown-overlay"
          onClick={() => setIsUserMenuOpen(false)}
        ></div>
      )}
    </header>
  );
};

export default Header;
